import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { PrivacySettings } from "../features/settings/PrivacySettings";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/settings/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return (
    <>
      <h2>{t("settings.privacy.title")}</h2>
      <PrivacySettings key={me.data.user.id} me={me.data} />
    </>
  );
}
